import { LeadParagraph } from "../../../../src/components/LeadParagraph";
import { Flex, FlexBehavior, FlexAlignItems, magma } from 'react-magma-dom';
import { OpenInNewIcon } from 'react-magma-icons';
import { StorybookIcon } from "../../../../src/images/icons/storybook-icon";
import * as React from 'react';
export default {
  LeadParagraph,
  Flex,
  FlexBehavior,
  FlexAlignItems,
  magma,
  OpenInNewIcon,
  StorybookIcon,
  React
};